import type {
  BoardColumnConfig,
  BoardConfig,
  CardView,
} from 'features/libra/dashboard/ticketDashboard/types'

import type { IndexedCard } from './cardIndex'
import { matchesSelection } from './cardIndex'

const OTHER_COLUMN_ID = '__other'

export interface ResolvedBoardColumn extends Omit<BoardColumnConfig, 'match'> {
  cards: CardView[]
}

/** A card can land in several columns when their `match` rules overlap. */
export function resolveBoardColumns(
  board: BoardConfig,
  rows: IndexedCard[]
): ResolvedBoardColumn[] {
  const matched = new Set<IndexedCard>()
  const columns = board.columns.map(({ match, ...column }) => {
    const columnRows = rows.filter((row) => matchesSelection(row, match))
    columnRows.forEach((row) => matched.add(row))
    return { ...column, cards: columnRows.map((row) => row.card) }
  })
  if (!board.otherColumn) return columns

  const unmatched = rows.filter((row) => !matched.has(row))
  return [
    ...columns,
    {
      id: OTHER_COLUMN_ID,
      ...board.otherColumn,
      cards: unmatched.map((row) => row.card),
    },
  ]
}
